export default __webpack_public_path__ + "assets/svg/no_announcement_types.7a2b8ee7.svg";